import { render, staticRenderFns } from "./AgentCarriers.vue?vue&type=template&id=0621400b&"
import script from "./AgentCarriers.vue?vue&type=script&lang=js&"
export * from "./AgentCarriers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports